var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizerScoreImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 157,
    viewBox: "0 0 199 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.516 156.976C119.418 157.025 119.222 156.976 118.944 156.927C118.944 156.927 118.912 156.927 118.895 156.927C115.794 156.159 99.9102 149.197 99.9102 149.197V137.414C103.126 137.414 119.516 134.211 119.516 134.211L119.597 136.271C119.597 136.271 119.597 136.418 119.597 136.483C119.842 142.17 120.332 156.616 119.516 156.992V156.976Z",
    fill: "url(#paint0_linear_1267_6050)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.895 156.927C115.794 156.159 100.188 149.198 100.188 149.198L99.9102 137.415H103.11C103.11 137.415 108.17 152.057 118.879 156.911L118.895 156.927Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.619 144.72C103.256 137.84 114.895 137.84 116.919 142.105C118.943 146.371 117.899 156.437 117.899 156.437C117.899 156.437 109.9 151.486 106.602 144.737L106.619 144.72Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.101 141.958C105.101 141.958 105.476 148.478 107.092 151.125C108.708 153.756 117.409 156.437 117.409 156.437C117.409 156.437 109.28 151.109 105.101 141.974V141.958Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.613 136.467L119.482 134.702C112.283 137.202 103.125 137.414 103.125 137.414C106.341 137.414 119.531 134.211 119.531 134.211L119.498 134.702L119.629 136.467H119.613Z",
    fill: "#BE2F55"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.351 140.373C104.351 140.373 111.664 151.747 117.916 156.421C117.916 156.421 107.697 150.129 104.351 140.373Z",
    fill: "#FFAB34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9089 137.415V149.198C99.9089 149.198 84.4987 156.159 81.4134 156.928C81.4134 156.928 81.3808 156.928 81.3645 156.928C81.0706 156.993 80.8911 157.026 80.7931 156.977C79.9769 156.584 80.4666 142.154 80.7115 136.467C80.7115 136.402 80.7115 136.32 80.7115 136.255L80.7931 134.196C80.7931 134.196 96.693 137.399 99.9252 137.399L99.9089 137.415Z",
    fill: "url(#paint1_linear_1267_6050)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4121 156.927C84.5137 156.159 100.185 149.198 100.185 149.198L99.9076 137.415H97.1814C97.1814 137.415 92.1209 152.057 81.4121 156.911V156.927Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6893 144.72C97.0521 137.84 85.4129 137.84 83.3887 142.105C81.3644 146.371 82.4092 156.437 82.4092 156.437C82.4092 156.437 90.4081 151.486 93.7056 144.737L93.6893 144.72Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1914 141.958C95.1914 141.958 94.8159 148.478 93.1998 151.125C91.5837 153.773 82.8828 156.437 82.8828 156.437C82.8828 156.437 91.0123 151.109 95.1914 141.974V141.958Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1816 137.415C97.1816 137.415 87.9584 137.497 80.743 134.997L80.6777 136.467V136.255L80.7757 134.196C80.7757 134.196 93.9494 137.399 97.1816 137.399V137.415Z",
    fill: "#BE2F55"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9581 140.373C95.9581 140.373 88.6448 151.747 82.3926 156.421C82.3926 156.421 92.6116 150.129 95.9581 140.373Z",
    fill: "#FFAB34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.566 108.473C153.566 91.2814 153.566 74.0896 153.566 56.9141C153.566 53.6784 152.603 50.2956 150.513 48.1058C136.442 36.7644 122.746 26.3056 104.479 22.645C101.573 21.8605 98.2264 21.8605 95.3207 22.645C77.0538 26.3056 63.374 36.7808 49.2861 48.1058C47.1965 50.2956 46.2334 53.6784 46.2334 56.9141V108.473C46.2334 111.709 47.1965 115.092 49.2861 117.282C63.3576 128.623 77.0538 139.082 95.3207 142.742C98.2264 143.527 101.573 143.527 104.479 142.742C122.746 139.082 136.425 128.607 150.513 117.282C152.603 115.092 153.566 111.709 153.566 108.473Z",
    fill: "#FEA338"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M146.351 60.3786V105.009C146.351 105.352 146.351 105.679 146.318 106.022C146.139 108.506 145.306 110.973 143.707 112.64C131.529 122.446 119.677 131.515 103.859 134.669C101.361 135.356 98.4554 135.356 95.9415 134.669C80.1395 131.515 68.288 122.446 56.0938 112.64C54.2818 110.745 53.4492 107.819 53.4492 105.009V60.3786C53.4492 57.5841 54.2818 54.6426 56.0938 52.7469C68.2717 42.9417 80.1232 33.8882 95.9415 30.7178C98.4554 30.0478 101.361 30.0478 103.859 30.7178C119.661 33.8882 131.512 42.9417 143.707 52.7469C145.519 54.6426 146.351 57.5841 146.351 60.3786Z",
    fill: "url(#paint2_linear_1267_6050)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0027 52.0767C47.0027 52.0767 51.7857 54.4136 53.4671 54.2011C55.1485 54.005 84.0263 30.1947 99.9098 30.1947C115.793 30.1947 141.243 51.5864 143.708 52.7467C146.173 53.907 151.201 48.9227 151.201 48.9227C151.201 48.9227 119.548 22.04 99.8935 22.04C80.239 22.04 47.574 49.609 46.9863 52.0767H47.0027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.318 106.022C146.139 108.506 145.306 110.974 143.706 112.641C131.529 122.446 119.677 131.516 103.859 134.67C101.361 135.356 98.4554 135.356 95.9415 134.67C80.1395 131.516 68.288 122.446 56.0938 112.641C54.2818 110.745 53.4492 107.82 53.4492 105.009C53.4492 105.009 73.5771 132.823 99.0921 132.823C124.607 132.823 146.302 106.022 146.302 106.022H146.318Z",
    fill: "#505050"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.904 143.347C96.496 141.794 98.4549 138.101 103.336 135.878C108.201 133.64 116.673 131.94 125.521 125.926C134.385 119.912 142.057 113.065 144.49 113.375C146.922 113.686 147.444 119.749 147.444 119.749C147.444 119.749 125.194 140.503 100.887 143.363L100.904 143.347Z",
    fill: "#BE2F55"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6744 53.6625C50.9355 54.8554 60.0772 47.8937 68.4026 43.0075C76.728 38.1212 76.826 29.7051 76.826 29.7051C76.826 29.7051 48.4379 43.1872 50.6744 53.6625Z",
    fill: "#FFF9C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6543 94.2363C62.8296 95.8542 64.0866 97.423 65.3926 98.9428C66.6659 100.479 67.9881 101.982 69.3757 103.421C72.1182 106.313 74.975 109.124 78.1256 111.543C81.2435 114.01 84.541 116.265 88.165 117.916C91.7727 119.55 95.6416 120.661 99.6574 120.906C95.6416 120.972 91.6421 120.057 87.9202 118.504C84.1819 116.935 80.8354 114.631 77.6358 112.196C74.4852 109.68 71.5958 106.852 68.935 103.845C66.2741 100.838 63.8091 97.6518 61.6869 94.2527L61.6543 94.2363Z",
    fill: "#A8A8A8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0359 110.561C74.8436 113.388 77.7004 116.15 80.802 118.569C82.3365 119.794 83.969 120.922 85.683 121.854C87.3971 122.785 89.2417 123.553 91.2333 123.749C89.2254 123.88 87.2175 123.243 85.4055 122.409C83.5608 121.576 81.8794 120.432 80.296 119.206C78.7288 117.964 77.227 116.624 75.8558 115.153C74.4845 113.699 73.1622 112.195 72.0195 110.545L72.0359 110.561Z",
    fill: "#A8A8A8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9385 59.3328C86.652 55.1982 92.7899 51.6193 99.336 48.9066C102.601 47.5502 106.013 46.4716 109.522 45.8669C113.016 45.2786 116.705 45.1806 120.166 46.2755C123.627 47.3541 126.614 49.8217 128.393 52.943C130.189 56.0644 131.136 59.5779 131.593 63.0914C132.458 70.1675 131.707 77.26 130.581 84.2217L131.136 78.9595C131.315 77.2109 131.332 75.446 131.43 73.6811C131.544 71.9325 131.43 70.1675 131.43 68.4026C131.332 66.654 131.185 64.9054 130.956 63.1731C130.418 59.725 129.503 56.2932 127.74 53.3189C125.994 50.3447 123.186 48.0404 119.905 47.0436C116.623 45.9813 113.065 46.0304 109.637 46.586C106.192 47.1416 102.846 48.2202 99.5645 49.4785C96.2997 50.7532 93.1164 52.2567 90.0148 53.9236C86.9132 55.5741 83.8605 57.3554 80.9385 59.3164V59.3328Z",
    fill: "#A8A8A8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5703 94.7261C62.7293 96.3439 63.9863 97.8801 65.2759 99.3836C66.5492 100.903 67.8552 102.407 69.2264 103.829C71.9526 106.688 74.7767 109.483 77.911 111.902C80.9963 114.353 84.2775 116.592 87.8525 118.259C91.4275 119.893 95.2638 121.02 99.2469 121.266C95.2638 121.331 91.2969 120.399 87.6076 118.831C83.902 117.262 80.5718 114.974 77.4049 112.539C74.2706 110.039 71.4139 107.228 68.7693 104.253C66.1248 101.263 63.6762 98.0925 61.5703 94.7261Z",
    fill: "#282828"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8877 110.904C74.6792 113.715 77.5196 116.444 80.6049 118.863C82.1394 120.089 83.7392 121.2 85.4532 122.131C87.1509 123.063 88.9793 123.831 90.9545 124.043C88.9466 124.174 86.9714 123.537 85.1594 122.703C83.3311 121.87 81.666 120.742 80.0988 119.517C78.5317 118.275 77.0462 116.951 75.6913 115.496C74.32 114.058 73.0304 112.555 71.8877 110.921V110.904Z",
    fill: "#282828"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6436 60.297C86.3081 56.0154 92.4134 52.2567 98.9595 49.3969C102.224 47.9588 105.636 46.7985 109.162 46.1284C112.672 45.4748 116.41 45.344 119.887 46.488C123.381 47.6156 126.286 50.2466 127.951 53.466C129.649 56.6854 130.433 60.248 130.874 63.7942C131.559 70.9356 130.776 78.0771 129.617 85.0878L130.204 79.793C130.4 78.0281 130.433 76.2468 130.547 74.4818C130.694 72.7169 130.58 70.9356 130.612 69.1707C130.596 67.4057 130.384 65.6408 130.253 63.8759C129.731 60.395 128.98 56.9142 127.315 53.8255C125.682 50.7532 122.94 48.3183 119.642 47.2724C116.361 46.1611 112.754 46.2428 109.309 46.8638C105.848 47.4848 102.486 48.6451 99.2207 49.9688C95.9558 51.3252 92.7725 52.9104 89.6872 54.659C86.5856 56.3912 83.5656 58.2542 80.6599 60.297H80.6436Z",
    fill: "#282828"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M186.836 70.2325C178.315 76.1157 150.335 77.0308 150.335 77.0308V53.4003C150.335 53.4003 196.647 31.7471 198.459 32.9237C200.287 34.1167 195.325 64.3494 186.836 70.2325Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.836 70.2322C178.315 76.1153 150.335 77.0304 150.335 77.0304V72.1278C150.335 72.1278 177.009 66.5062 181.678 61.0316C186.33 55.5734 198.475 32.9233 198.475 32.9233C200.304 34.1163 195.341 64.349 186.853 70.2322H186.836Z",
    fill: "#BE2F55"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.453 94.9093C174.642 96.3147 150.335 94.9093 150.335 94.9093V75.3479C150.335 75.3479 193.056 63.6143 196.598 66.4251C196.712 66.4905 196.778 66.5886 196.81 66.6866C197.659 68.9745 188.338 93.0136 180.453 94.9256V94.9093Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.453 94.9092C174.642 96.3146 150.335 94.9092 150.335 94.9092V90.6929C150.335 90.6929 165.761 90.9707 175.899 87.7187C183.963 85.1366 193.97 70.3144 196.614 66.4087C196.729 66.4741 196.794 66.5721 196.827 66.6702C197.676 68.958 188.354 92.9971 180.47 94.9092H180.453Z",
    fill: "#BE2F55"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M149.061 111.399C149.061 111.399 149.371 109.111 149.648 105.973C149.991 102.623 150.318 98.3252 150.318 94.8934C150.318 94.8934 172.241 94.3214 173.155 94.8934C174.069 95.4653 166.87 113.589 149.061 111.399Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M149.061 111.398C149.061 111.398 149.371 109.11 149.648 105.972L150.318 105.27C150.318 105.27 166.462 104.24 173.155 94.9087C174.069 95.4807 166.87 113.604 149.061 111.414V111.398Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.336 75.3317L150.222 72.7497C150.222 72.7497 174.822 65.2977 179.54 63.925C184.242 62.5523 190.543 65.9024 190.543 65.9024C190.543 65.9024 176.259 67.7327 150.336 75.3317Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.335 94.9089V90.6926C150.335 90.6926 169.63 89.6304 173.597 89.4833C177.564 89.3363 180.453 94.9089 180.453 94.9089L173.597 95.4972L173.156 94.9089H150.318H150.335Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.228 71.5073C157.47 73.3376 167.803 85.6758 174.578 86.2805C181.353 86.8851 192.91 71.017 194.118 68.5167C195.326 66.0164 173.37 69.0233 164.228 71.491V71.5073Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M166.187 46.128C163.477 47.7295 154.629 65.6894 154.711 68.5329C154.792 71.3764 175.883 66.5555 182.495 60.0024C189.106 53.4492 195.032 36.1104 195.032 36.1104C195.032 36.1104 179.246 38.3655 166.187 46.128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M158.888 95.1053C150.498 97.2297 151.51 103.587 151.755 104.486C151.999 105.384 161.043 103.963 165.402 101.201C169.76 98.439 172.699 95.5302 172.699 95.5302C172.699 95.5302 161.549 94.4352 158.888 95.1053Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.34 72.8635C195.829 71.0495 188.647 78.8773 187.733 82.1294C186.818 85.3651 188.075 87.7347 188.075 87.7347C188.075 87.7347 193.838 78.5341 195.34 72.8798V72.8635Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M198.67 37.8599C197.266 37.2226 193.087 60.7061 193.087 60.7061C193.087 60.7061 197.658 49.7406 198.67 37.8599Z",
    fill: "white"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.435 71.4418C153.435 71.4418 174.868 64.4475 179.945 60.7051C185.006 56.9628 192.825 43.1538 192.825 43.1538C192.825 43.1538 184.908 59.218 179.798 62.6008C174.689 65.9836 153.435 71.4582 153.435 71.4582V71.4418Z",
    fill: "#FFD134"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M150.335 90.6933C150.335 90.6933 168.308 88.7322 174.87 86.9019C181.433 85.0716 191.146 74.0244 191.146 74.0244C191.146 74.0244 181.89 86.0685 176.046 88.34C170.202 90.6279 150.335 90.6769 150.335 90.6769V90.6933Z",
    fill: "#FFAB34"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M149.828 104.224C149.828 104.224 156.146 103.685 161.778 102.116C167.393 100.547 170.397 97.9326 170.397 97.9326C170.397 97.9326 161.696 105.548 149.844 105.45V104.224H149.828Z",
    fill: "#FFAB34"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M175.685 63.5976C172.861 63.8264 174.167 57.5511 179.636 55.8352C185.104 54.1192 182.476 63.0583 175.685 63.5976Z",
    fill: "#FFF9C7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1489 70.2328C20.6702 76.1159 48.6502 77.0311 48.6502 77.0311V53.4005C48.6502 53.4005 2.338 31.7637 0.525997 32.924C-1.30233 34.1169 3.66027 64.3497 12.1489 70.2328Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1489 70.2322C20.6702 76.1153 48.6502 77.0304 48.6502 77.0304V72.1278C48.6502 72.1278 21.9762 66.5062 17.3074 61.0316C12.6713 55.5734 0.525997 32.9233 0.525997 32.9233C-1.30233 34.1163 3.66027 64.349 12.1489 70.2322Z",
    fill: "#BE2F55"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5321 94.909C24.3436 96.3144 48.6505 94.909 48.6505 94.909V75.3476C48.6505 75.3476 5.92971 63.5977 2.38732 66.4085C2.27305 66.4739 2.20776 66.5719 2.17511 66.67C1.32624 68.9579 10.6474 92.997 18.5321 94.909Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5328 94.9092C24.3443 96.3146 48.6512 94.9092 48.6512 94.9092V90.6929C48.6512 90.6929 33.2247 90.9707 23.0873 87.7187C15.0231 85.1366 5.01624 70.3144 2.3717 66.4087C2.25743 66.4741 2.19213 66.5721 2.15948 66.6702C1.31062 68.958 10.6318 92.9971 18.5165 94.9092H18.5328Z",
    fill: "#BE2F55"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9235 111.399C49.9235 111.399 49.6133 109.111 49.3358 105.973C48.993 102.623 48.6665 98.3252 48.6665 94.8934C48.6665 94.8934 26.7429 94.3214 25.8288 94.8934C24.9146 95.4653 32.1136 113.589 49.9235 111.399Z",
    fill: "#FEA338"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9235 111.398C49.9235 111.398 49.6133 109.11 49.3358 105.972L48.6665 105.27C48.6665 105.27 32.5217 104.24 25.8288 94.9087C24.9146 95.4807 32.1136 113.604 49.9235 111.414V111.398Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6668 75.3317L48.7811 72.7497C48.7811 72.7497 24.1803 65.2977 19.4626 63.925C14.7612 62.5523 8.45996 65.9024 8.45996 65.9024C8.45996 65.9024 22.7438 67.7327 48.6668 75.3317Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6653 94.9089V90.6926C48.6653 90.6926 29.3699 89.6304 25.4031 89.4833C21.4363 89.3363 18.5469 94.9089 18.5469 94.9089L25.4031 95.4972L25.8439 94.9089H48.6816H48.6653Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7571 71.5078C41.5154 73.3381 31.1821 85.6763 24.4075 86.281C17.6329 86.8856 6.07524 71.0175 4.86724 68.5172C3.65924 66.0169 25.6155 69.0238 34.7571 71.4914V71.5078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8148 46.128C35.5247 47.7295 44.3725 65.6894 44.2908 68.5329C44.2092 71.3764 23.1182 66.5555 16.5068 60.0024C9.89546 53.4492 3.96973 36.1104 3.96973 36.1104C3.96973 36.1104 19.7554 38.3655 32.8148 46.128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1121 95.1048C48.5029 97.2292 47.4908 103.586 47.2459 104.485C47.001 105.384 37.9573 103.962 33.5987 101.2C29.2401 98.4385 26.3018 95.5297 26.3018 95.5297C26.3018 95.5297 37.4513 94.4347 40.1121 95.1048Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64306 72.8635C3.15333 71.0495 10.336 78.8773 11.2502 82.1294C12.1644 85.3651 10.9074 87.7347 10.9074 87.7347C10.9074 87.7347 5.1449 78.5341 3.64306 72.8798V72.8635Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0.313477 37.8599C1.71737 37.2226 5.8964 60.7061 5.8964 60.7061C5.8964 60.7061 1.32559 49.7406 0.313477 37.8599Z",
    fill: "white"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5479 71.4418C45.5479 71.4418 24.114 64.4475 19.0371 60.7051C13.9603 56.9628 6.15723 43.1538 6.15723 43.1538C6.15723 43.1538 14.0745 59.218 19.1841 62.6008C24.2936 65.9836 45.5479 71.4582 45.5479 71.4582V71.4418Z",
    fill: "#FFD134"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 90.6933C48.6663 90.6933 30.6932 88.7322 24.1308 86.9019C17.5685 85.0716 7.85547 74.0244 7.85547 74.0244C7.85547 74.0244 17.1114 86.0685 22.9555 88.34C28.7996 90.6279 48.6663 90.6769 48.6663 90.6769V90.6933Z",
    fill: "#FFAB34"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1722 104.224C49.1722 104.224 42.8547 103.685 37.2228 102.116C31.6072 100.547 28.6035 97.9326 28.6035 97.9326C28.6035 97.9326 37.3044 105.548 49.1559 105.45V104.224H49.1722Z",
    fill: "#FFAB34"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.297 63.5976C26.1211 63.8264 24.8151 57.5511 19.3465 55.8352C13.8778 54.1192 16.506 63.0583 23.297 63.5976Z",
    fill: "#FFF9C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M192.386 42.1411C189.856 41.4384 186.493 46.4554 188.403 50.4919C190.281 54.463 198.149 43.7426 192.386 42.1411Z",
    fill: "url(#paint3_linear_1267_6050)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M188.551 45.7204C188.387 48.711 192.158 48.7764 193.562 47.1912C194.966 45.5897 194.835 42.0762 192.044 42.0762C189.252 42.0762 188.534 45.7204 188.534 45.7204H188.551Z",
    fill: "#BE2F55"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M187.848 48.318C188.615 46.5041 190.884 48.6449 192.239 48.7102C193.594 48.7756 191.341 51.7662 189.774 51.374C188.207 50.9818 187.848 48.318 187.848 48.318Z",
    fill: "#FFDE00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3538 54.1681C64.6966 60.4598 72.4507 55.4592 72.9567 50.6383C73.4791 45.5722 64.011 47.6313 64.3538 54.1681Z",
    fill: "#C4C4C4",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M11.9185 48.6942C14.5957 46.0141 21.0601 48.1222 26.3329 53.417C31.622 58.7118 33.7278 65.1669 31.0506 67.847C28.3734 70.5271 21.909 68.419 16.6362 63.1242C11.3471 57.8294 9.2413 51.3743 11.9185 48.6942Z",
    fill: "url(#paint4_radial_1267_6050)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M163.067 89.3527C162.055 86.6563 165.548 82.8649 170.87 80.8712C176.176 78.8938 181.301 79.4658 182.313 82.1622C183.326 84.8586 179.832 88.65 174.51 90.6437C169.205 92.6211 164.079 92.0491 163.067 89.3527Z",
    fill: "url(#paint5_radial_1267_6050)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M112.657 26.4196C114.093 24.2298 118.974 24.9161 123.561 27.9394C128.148 30.9627 130.695 35.1789 129.259 37.3688C127.822 39.5586 122.941 38.8722 118.354 35.849C113.767 32.8257 111.22 28.6094 112.657 26.4196Z",
    fill: "url(#paint6_radial_1267_6050)"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M123.219 24.7208C118.501 26.0282 114.224 31.895 114.224 31.895C103.352 25.8648 88.9706 29.2149 82.7183 31.895C82.7183 31.895 78.4414 26.0282 73.7236 24.7208C73.7236 24.7208 80.5146 0.0117188 98.455 0.0117188C116.395 0.0117188 123.203 24.7208 123.203 24.7208H123.219Z",
    fill: "url(#paint7_linear_1267_6050)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1064 19.8825C80.188 21.1572 89.395 25.8637 98.4713 25.8637C107.548 25.8637 116.461 21.9089 117.065 21.0918C117.669 20.2747 110.78 3.75293 99.108 3.75293C87.4361 3.75293 80.0085 18.3464 80.1064 19.8662V19.8825Z",
    fill: "url(#paint8_linear_1267_6050)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7948 18.8699C83.8601 19.8831 91.2223 23.6581 98.503 23.6581C105.784 23.6581 112.917 20.4878 113.391 19.8341C113.881 19.1804 108.363 5.94336 99.0091 5.94336C89.6552 5.94336 83.7132 17.6279 83.7948 18.8536V18.8699Z",
    fill: "url(#paint9_linear_1267_6050)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6582 16.2382C81.6582 16.2382 90.2775 7.05402 98.4723 7.05402C106.667 7.05402 115.597 16.8429 115.597 16.8429C115.597 16.8429 108.577 3.75293 99.1089 3.75293C89.6408 3.75293 81.6582 16.2382 81.6582 16.2382Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1657 18.756C84.4148 18.2331 93.9808 15.8798 100.462 15.9452C106.942 16.0106 110.942 18.5272 111.301 19.6712C111.66 20.8151 96.5111 26.5675 85.182 18.756H85.1657Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.89
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3422 11.0579C86.5223 15.1434 94.2927 15.7154 99.9083 15.4212C105.524 15.1107 106.667 10.2571 106.454 9.53807C106.242 8.83536 96.5128 4.43936 90.3422 11.0579Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M123.219 24.7198C118.501 26.0272 114.224 31.894 114.224 31.894C101.051 28.5275 98.2101 30.2108 82.7183 31.894C82.7183 31.894 78.4414 26.0272 73.7236 24.7198C73.7236 24.7198 75.6009 22.0071 79.6983 22.7752C83.7958 23.5432 89.4277 28.0209 98.455 27.9556C107.499 27.8739 115.449 21.1083 123.203 24.7198H123.219Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2988 15.9613C77.2988 15.9613 86.7996 4.71796 97.7043 3.86818C108.609 3.00205 117.098 15.9613 117.098 15.9613C117.098 15.9613 112.968 -0.495141 98.4552 0.0114611C83.9428 0.518064 77.2988 15.9613 77.2988 15.9613Z",
    fill: "white"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M104.691 1.80852C102.194 2.02096 108.495 7.38115 109.932 7.96946C111.368 8.55777 110.013 1.35094 104.691 1.80852Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M83.2716 29.9983C83.2716 32.8418 80.9699 35.1461 78.1295 35.1461C75.289 35.1461 72.9873 32.8418 72.9873 29.9983C72.9873 27.1548 75.289 24.8506 78.1295 24.8506C80.9699 24.8506 83.2716 27.1548 83.2716 29.9983Z",
    fill: "url(#paint10_radial_1267_6050)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M79.9604 29.9983C79.9604 31.0115 79.1441 31.8286 78.132 31.8286C77.1199 31.8286 76.3037 31.0115 76.3037 29.9983C76.3037 28.9851 77.1199 28.168 78.132 28.168C79.1441 28.168 79.9604 28.9851 79.9604 29.9983Z",
    fill: "url(#paint11_radial_1267_6050)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M112.266 24.8832C113.574 24.8832 114.633 23.8223 114.633 22.5136C114.633 21.2049 113.574 20.144 112.266 20.144C110.959 20.144 109.899 21.2049 109.899 22.5136C109.899 23.8223 110.959 24.8832 112.266 24.8832Z",
    fill: "url(#paint12_radial_1267_6050)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M112.265 23.3475C112.725 23.3475 113.098 22.9744 113.098 22.5141C113.098 22.0538 112.725 21.6807 112.265 21.6807C111.805 21.6807 111.433 22.0538 111.433 22.5141C111.433 22.9744 111.805 23.3475 112.265 23.3475Z",
    fill: "url(#paint13_radial_1267_6050)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1267_6050",
    x1: 109.933,
    y1: 157.009,
    x2: 109.933,
    y2: 134.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1267_6050",
    x1: 90.1143,
    y1: 157.009,
    x2: 90.1143,
    y2: 134.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1267_6050",
    x1: 141.075,
    y1: 134.92,
    x2: 99.9083,
    y2: 30.2113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#535353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1267_6050",
    x1: 191.146,
    y1: 51.3743,
    x2: 191.146,
    y2: 42.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#D36500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BC4500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A92C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9D1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#951000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#930D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8589 57.5609) rotate(-134.969) scale(13.4768 6.92559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.096 76.9521) rotate(159.53) scale(10.2269 5.2598)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.952 32.3707) rotate(-146.602) scale(9.9585 4.72979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A68F95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1267_6050",
    x1: 98.4713,
    y1: 31.895,
    x2: 98.4713,
    y2: 0.0117188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B93E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1267_6050",
    x1: 98.6019,
    y1: 25.8637,
    x2: 98.6019,
    y2: 3.75293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ED8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#CA6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#AF4200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9C2A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#901C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8D1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#951F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A42E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#AD3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1267_6050",
    x1: 98.601,
    y1: 23.6581,
    x2: 98.601,
    y2: 5.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#015E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0393B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#05ABCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#06A1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#07C9F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0786FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#086BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1458 28.5981) scale(4.86465 4.72382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1484 28.3242) scale(1.63243 1.56883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF009D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.266 21.1319) scale(2.25275 2.18754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#950059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1267_6050",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.265 20.8727) scale(0.750923 0.721662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF009D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizerScoreImg);
export default __webpack_public_path__ + "static/media/wizer-score-img.434942f3afb47b4e2605232814cb3995.svg";
export { ForwardRef as ReactComponent };